import NextAxios from './nextAxios';
import NextFetch from './nextFetch';
/**
 * 注意：Axios这种方式的请求无法单独设置ssr或者isr模式，其他跟传统csr一致，建议需要文件上传进度的使用Axios方式
 * 注意：Axios这种方式的请求无法单独设置ssr或者isr模式，其他跟传统csr一致，建议需要文件上传进度的使用Axios方式
 * 注意：Axios这种方式的请求无法单独设置ssr或者isr模式，其他跟传统csr一致，建议需要文件上传进度的使用Axios方式
 */
export { NextFetch, NextAxios };
